import { render } from "./Refferal.vue?vue&type=template&id=b400c500"
import script from "./Refferal.vue?vue&type=script&lang=js"
export * from "./Refferal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__